export default {
  API_URL: 'http://api.pre.test.deyouhui.com.cn',
  RBAC_URL: 'http://rbac.pre.test.deyouhui.com.cn',
  AUDIT_URL: 'http://audit.pre.test.deyouhui.com.cn',
};
